// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"Groups_wrapperSelect__AHR+y","select":"Groups_select__GwkAz"};